import IconHeart from './IconHeart';

export default IconHeart;
